<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    [formGroup]="storageInfo"
    class="storage-service-form"
    (ngSubmit)="handleSave()"
    [attr.data-cy]="E2eLocators.DIALOG_CONTENT"
  >
    <div class="add-storage-dialog-contianer">
      <div mat-dialog-title class="mat-headline-5 add-storage-service-title">
        Add storage service
      </div>
      <div class="name property">
        <div class="mat-body-1 property-header">Name</div>
        <mat-form-field appearance="outline" class="text-field">
          <input
            matInput
            formControlName="name"
            autocomplete="off"
            [attr.data-cy]="E2eLocators.ADMIN_CALL_RECORDING_STORAGE_SERVICE_NAME"
          />
          <mat-error>{{ getGenericRequiredError(storageInfo.controls.name, "Name") }}</mat-error>
        </mat-form-field>
      </div>
      <div class="property storage-service-prop">
        <div>
          <div class="mat-body-1 property-header">Service</div>
          @if (this.storageInfo.controls.storageService.value !== 'Google Cloud') {
          <mat-radio-group
            color="primary"
            formControlName="storageService"
            class="storage-service-radio-group"
          >
            <mat-radio-button
              [value]="'AWS'"
              [attr.data-cy]="E2eLocators.ADMIN_CALL_RECORDING_STORAGE_SERVICE_AWS"
            >
              <span class="radio-option">Amazon web services</span>
            </mat-radio-button>
            <mat-radio-button
              [value]="'Google Cloud'"
              [attr.data-cy]="E2eLocators.ADMIN_CALL_RECORDING_STORAGE_SERVICE_GOOGLE_CLOUD"
            >
              <span class="radio-option">Google Cloud</span>
            </mat-radio-button>
            <mat-radio-button
              [value]="'Rackspace'"
              [attr.data-cy]="E2eLocators.ADMIN_CALL_RECORDING_STORAGE_SERVICE_ROCK_SPACE"
            >
              <span class="radio-option">Rackspace</span>
            </mat-radio-button>
          </mat-radio-group>
          } @if (this.storageInfo.controls.storageService.value === 'Google Cloud') {
          <mat-radio-group
            color="primary"
            formControlName="storageService"
            class="storage-service-radio-group"
          >
            <mat-radio-button [value]="'AWS'" onsip-mat-radio-button-label-align-normal>
              <span class="radio-option">Amazon web services</span>
            </mat-radio-button>
            <mat-radio-button [value]="'Google Cloud'" onsip-mat-radio-button-label-align-normal>
              <span class="radio-option">Google Cloud</span>
            </mat-radio-button>
            <mat-radio-button [value]="'Rackspace'" onsip-mat-radio-button-label-align-normal>
              <span class="radio-option">Rackspace</span>
            </mat-radio-button>
          </mat-radio-group>
          }
        </div>
        @if (storageInfo.controls.storageService.value === 'Google Cloud') {
        <div class="project-id">
          <div class="mat-body-1 property-header">Project ID</div>
          <mat-form-field appearance="outline" class="text-field onsip-hack-responsive-suffix">
            <input matInput formControlName="gCloudProjectId" autocomplete="off" />
            <mat-error>{{
              getFieldError(storageInfo.controls.gCloudProjectId, "Project Id")
            }}</mat-error>
          </mat-form-field>
        </div>
        }
      </div>
      @if (storageInfo.controls.storageService.value === 'AWS') {
      <div class="bucket-name property">
        <div class="mat-body-1 property-header">Bucket name</div>
        <mat-form-field appearance="outline" class="text-field">
          <input
            matInput
            formControlName="awsBucketName"
            autocomplete="off"
            [attr.data-cy]="E2eLocators.ADMIN_CALL_RECORDING_STORAGE_SERVICE_AWS_BUCKET_NAME"
          />
          <mat-error>{{
            getFieldError(storageInfo.controls.awsBucketName, "Bucket name")
          }}</mat-error>
        </mat-form-field>
      </div>
      } @if (storageInfo.controls.storageService.value === 'Google Cloud') {
      <div class="bucket-name property">
        <div class="mat-body-1 property-header">Bucket name</div>
        <mat-form-field appearance="outline" class="text-field">
          <input matInput formControlName="gCloudBucketName" autocomplete="off" />
          <mat-error>{{
            getFieldError(storageInfo.controls.gCloudBucketName, "Bucket name")
          }}</mat-error>
        </mat-form-field>
      </div>
      } @if (storageInfo.controls.storageService.value === 'Rackspace') {
      <div class="container-name property">
        <div class="mat-body-1 property-header">Container name</div>
        <mat-form-field appearance="outline" class="text-field">
          <input
            matInput
            formControlName="rackspaceContainerName"
            autocomplete="off"
            [attr.data-cy]="E2eLocators.ADMIN_CALL_RECORDING_STORAGE_SERVICE_ROCK_SPACE_NAME"
          />
          <mat-error>{{
            getFieldError(storageInfo.controls.rackspaceContainerName, "Container name")
          }}</mat-error>
        </mat-form-field>
      </div>
      } @if (storageInfo.controls.storageService.value === 'AWS') {
      <div class="access-props property">
        <div class="access-key access-prop">
          <div>
            <div class="mat-body-1 property-header">Access Key</div>
            <mat-form-field appearance="outline" class="text-field onsip-hack-responsive-suffix">
              <input
                matInput
                formControlName="awsAccessKey"
                autocomplete="off"
                [attr.data-cy]="E2eLocators.ADMIN_CALL_RECORDING_STORAGE_SERVICE_AWS_ACCESS_KEY"
              />
              <mat-error>{{
                getFieldError(storageInfo.controls.awsAccessKey, "Access Key")
              }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="secret-key access-prop">
          <div>
            <div class="mat-body-1 property-header">Secret Key</div>
            <mat-form-field appearance="outline" class="text-field onsip-hack-responsive-suffix">
              <input
                matInput
                formControlName="awsSecretKey"
                autocomplete="off"
                [attr.data-cy]="E2eLocators.ADMIN_CALL_RECORDING_STORAGE_SERVICE_AWS_SECRET_KEY"
              />
              <mat-error>{{
                getFieldError(storageInfo.controls.awsSecretKey, "Secret Key")
              }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      } @if (storageInfo.controls.storageService.value === 'AWS' && isCashExpress) {
      <div class="custom-url property">
        <div class="mat-body-1 property-header">Custom Url</div>
        <mat-form-field appearance="outline" class="text-field">
          <input matInput formControlName="awsCustomUrl" autocomplete="off" />
          <mat-error>{{ "Custom url must start with http:// or https:// ." }}</mat-error>
        </mat-form-field>
      </div>
      } @if (storageInfo.controls.storageService.value === 'Rackspace') {
      <span class="access-props property">
        <div class="api-key access-prop">
          <div class="mat-body-1 property-header">API Key</div>
          <mat-form-field appearance="outline" class="text-field onsip-hack-responsive-suffix">
            <input
              matInput
              formControlName="rackspaceApiKey"
              autocomplete="off"
              [attr.data-cy]="E2eLocators.ADMIN_CALL_RECORDING_STORAGE_SERVICE_ROCK_SPACE_API_KEY"
            />
            <mat-error>{{
              getFieldError(storageInfo.controls.rackspaceApiKey, "API Key")
            }}</mat-error>
          </mat-form-field>
        </div>
        <div class="username access-prop">
          <div class="mat-body-1 property-header">Username</div>
          <mat-form-field appearance="outline" class="text-field onsip-hack-responsive-suffix">
            <input
              matInput
              formControlName="rackspaceUsername"
              autocomplete="off"
              [attr.data-cy]="E2eLocators.ADMIN_CALL_RECORDING_STORAGE_SERVICE_ROCK_SPACE_USERNAME"
            />
            <mat-error>{{
              getFieldError(storageInfo.controls.rackspaceUsername, "Username")
            }}</mat-error>
          </mat-form-field>
        </div>
      </span>
      } @if (storageInfo.controls.storageService.value === 'Google Cloud') {
      <span class="upload-prop property">
        <div class="mat-body-1 property-header">Key file</div>
        <input
          #fileInput
          type="file"
          (change)="onFileChange(fileInput)"
          class="key-upload-input"
          name="StorageKeyFile"
        />
        @if (!storageInfo.controls.fileName.value) {
        <div>
          <button mat-stroked-button type="button" color="primary" (click)="fileInput.click()">
            Upload file
          </button>
        </div>
        } @if (storageInfo.controls.fileName.value) {
        <div>
          <span>{{ storageInfo.controls.fileName.value }}</span>
          <button mat-button type="button" color="primary" (click)="fileInput.click()">
            Replace
          </button>
        </div>
        }
        <mat-error>{{ getStorageKeyError() }}</mat-error>
      </span>
      }
    </div>
    <div mat-dialog-actions>
      <div class="add-storage-actions">
        <button mat-button type="button" color="primary" (click)="cancel()">Cancel</button>
        <button
          mat-flat-button
          [attr.data-cy]="E2eLocators.MODAL_CONFIRM_YES"
          type="submit"
          color="primary"
        >
          {{ data ? "Save changes" : "Add storage" }}
        </button>
      </div>
    </div>
  </form>
</onsip-loading-container>
